// @flow
export const AusStates = [
  { value: "NSW", label: "New South Wales (NSW)" }, 
  { value: "QLD", label: "Queensland (QLD)" },
  { value: "SA", label: "South Australia (SA)" },
  { value: "TAS", label: "Tasmania (TAS)" }, 
  { value: "VIC", label: "Victoria (VIC)" }, 
  { value: "WA", label: "Western Australia (WA)" }, 
  { value: "ACT", label: "Australian Capital Territory (ACT)" }, 
  { value: "NT", label: "Northern Territory (NT)" },
  { value: "Other", label: "Other" }
];